module.exports = __webpack_public_path__ + "static/img/connectionfail.30c25d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/connectionfail.png
// module id = Ltgc
// module chunks = 1